import el from './el.json';
import en from './en.json';

export const errorResources = {
  en,
  el,
};
